import { ISortingModel } from "../../../../Common/models/grid";

export const processedRequestsDefaultSorting = {
  field: "updatedOn",
  sort: "asc",
} as ISortingModel;
